/**
 * ProfitSystem logo — official brand PNG (minimal padding, no clipping needed).
 * Props:
 *   height {number} — height in px (default: 44)
 */
export default function ProfitSystemLogo({ height = 44 }) {
  return (
    <img
      src="https://customer-assets-7cd3h4nn.emergentagent.net/job_349d1ca9-f0e8-4d01-bcb4-57358f13c4a2/artifacts/yt5141p7_logo%20profitsystem.png"
      alt="ProfitSystem"
      style={{ height: `${height}px`, width: "auto", display: "block" }}
    />
  );
}
